<template>
  <!--------SidePane-------------->
  <sidebar-menu :menu="menu" :collapsed="collapsed" @toggle-collapse="onToggleCollapse" @item-click="onItemClick"/>
</template>

<script>
//Import Packages
import { mapGetters,mapActions } from "vuex";
import { SidebarMenu } from "vue-sidebar-menu";

export default {
  name: "HomeSidePane",
  components: {
    SidebarMenu,
  },
  props: {
    
 
    // Sidebar Collapse state
    collapsed: {
      type: Boolean,
      default: false
    },
  },  
  computed: {
    ...mapGetters({
      userBuckets: "userBuckets",
    }),
  },

  data() {
    return {
      menu: [],
      icons: {
        macro: "fas fa-chart-line",
        sector: "fas fa-chart-pie",
        stock: "fas fa-coins",
        valuation: "fas fa-hand-holding-usd",
        coverage: "fas fa-globe-americas",
        sensitivity: "fas fa-chart-bar",
        waterfall: "fab fa-cloudversify",
      },
    };
  },
  mounted() {
    this.setMenu();
  },
  methods: {
    ...mapActions(["sortbuckets"]),
    setMenu() {
      let childs = [];
      this.userBuckets.forEach((element) => {
        childs.push({
          href: { path: `/`+element.path, external:true },
          name: element.path,
          for:'nav',
          title: element.title,
          icon: this.icons[
            element.image.indexOf("/") >= 0
              ? element.image.split("/")[0]
              : element.image
          ],
        });
      });
      this.menu.push({
        href:'',
        title:'Dashboard',
        icon:'fas fa-tachometer-alt',
        child:childs
        },{
          href:'',
          title:'Sort',
          icon:'fas fa-sort',
          child:[{href:'',title:'Ascending',id:'asc',name:'asc',for:'bucketSort'},{href:'',title:'Descending',id:'desc',name:'desc',for:'bucketSort'}],
          exact: true
        });
        if(typeof this.menu != 'undefined' && this.menu.length > 0){
          if(this.$router.currentRoute.path == '/dashboard'){
            this.menu[1].hidden = false;
          }else {
            this.menu[1].hidden = true;
          }
        }
    },
    onToggleCollapse(collapsed) {
      
      this.$emit('clicked', collapsed)
    },
    onItemClick(event, item, node){
      if(item.for == 'bucketSort'){
        this.sortbuckets(item.name);
      }
    }
  },
  
};
</script>

<style lang="scss">
.sidePaneCard {
  .btn-secondary {
    background-color: transparent !important;
    border-color: transparent !important;
    text-align: left !important;
  }

  .dropdown-menu {
    background-color: transparent !important;
    border: transparent !important;
    color: #fff !important;
    margin: 0 !important;
    padding: 0 !important;
    cursor: pointer;
  }

  .dropdown-item {
    color: #fff !important;
    padding: 0 1.2rem !important;
    font-size: 14px !important;
    cursor: pointer;
  }

  .dropdown-item:hover {
    color: #333 !important;
  }

  .icon {
    height: 15px;
    width: 15px;
    position: relative;
    top: -2px;
    cursor: pointer;
  }

  height: 76vh;
  width: 192px;
  background: rgb(52, 63, 75);
  color: #fff;
  padding: 1em 0em;
  left: 0;
  position: absolute;
  display: inline-block;
}
.vsm--icon{
  background: transparent!important;
}
.router-link-active.vsm--link {
  background: #121212;
}
.v-sidebar-menu .vsm--dropdown>.vsm--list {
  padding: 0 !important;
}
</style>
